import {
  DateRangeSelection,
  GRAPH_BY_OPTIONS,
  GraphBy,
  RANGE_MODE_OPTIONS,
  RANGE_UNIT_OPTIONS,
  RangeMode,
  RangeUnit,
  todayKey,
} from './constants';

const selectClass =
  'rounded-lg border border-gray-300 bg-white px-2 py-1.5 text-xs font-semibold text-gray-700 outline-none focus:border-purple-700';

export const DateRangePicker = ({value, onChange}: {value: DateRangeSelection; onChange: (value: DateRangeSelection) => void}) => (
  <div className="flex flex-wrap items-center gap-3 rounded-lg border border-gray-300 bg-white px-3 py-2">
    <div className="flex items-center gap-1.5">
      <select value={value.mode} onChange={(e) => onChange({...value, mode: e.target.value as RangeMode})} className={selectClass}>
        {RANGE_MODE_OPTIONS.map((opt) => (
          <option key={opt.key} value={opt.key}>
            {opt.label}
          </option>
        ))}
      </select>
      {value.mode === 'relative' ? (
        <>
          <input
            type="number"
            min={1}
            value={value.amount}
            onChange={(e) => onChange({...value, amount: Math.max(1, Number(e.target.value) || 1)})}
            className={`${selectClass} w-14 text-center`}
          />
          <select value={value.unit} onChange={(e) => onChange({...value, unit: e.target.value as RangeUnit})} className={selectClass}>
            {RANGE_UNIT_OPTIONS.map((opt) => (
              <option key={opt.key} value={opt.key}>
                {value.amount === 1 ? opt.label : opt.pluralLabel}
              </option>
            ))}
          </select>
        </>
      ) : (
        <>
          <input
            type="date"
            value={value.startDay}
            max={value.endDay || todayKey()}
            onChange={(e) => e.target.value && onChange({...value, startDay: e.target.value})}
            className={selectClass}
          />
          <span className="text-xs font-semibold text-gray-500">and</span>
          <input
            type="date"
            value={value.endDay}
            min={value.startDay || undefined}
            max={todayKey()}
            onChange={(e) => e.target.value && onChange({...value, endDay: e.target.value})}
            className={selectClass}
          />
        </>
      )}
    </div>
    <div className="hidden h-5 w-px bg-gray-200 sm:block" />
    <div className="flex items-center gap-1.5">
      <span className="text-xs font-semibold text-gray-500">Graph by</span>
      <select value={value.graphBy} onChange={(e) => onChange({...value, graphBy: e.target.value as GraphBy})} className={selectClass}>
        {GRAPH_BY_OPTIONS.map((opt) => (
          <option key={opt.key} value={opt.key}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  </div>
);
